import React, { useState, useRef, useEffect } from 'react';
import './dropdown.css';
const Dropdown = ({
  btn,
  list,
  id,
  isHover = false,
  customDropdwon,
  isMouseOver = true,
  callBack = null,
}) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const handleOpen = (e) => {
    e.preventDefault();
    setShow(!show);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref]);

  return (
    <div className='dropdown' ref={ref} id={id}>
      <div
        className='dropdown-toggle'
        role='button'
        data-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded={show}
        {...(isHover
          ? {
              onMouseEnter: () => {
                setShow(true);
              },

              onClick: undefined,
            }
          : {
              onClick: (e) => {
                handleOpen(e);
              },
            })}
      >
        {btn}
      </div>
      <div
        className={`${
          show && isMouseOver ? 'show' : ''
        } text-general dropdown-menu ${customDropdwon} mt-2`}
        aria-labelledby={id}
        onClick={(e) => {
          handleOpen(e);
          callBack && callBack();
        }}
      >
        {list}
      </div>
    </div>
  );
};

export default Dropdown;
